import { render, staticRenderFns } from "./FulfillmentContactList.vue?vue&type=template&id=5b31eda9&scoped=true"
import script from "./FulfillmentContactList.vue?vue&type=script&lang=js"
export * from "./FulfillmentContactList.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentContactList.vue?vue&type=style&index=0&id=5b31eda9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31eda9",
  null
  
)

export default component.exports